"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/Details/SenderPickerController.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _reacthookform = require('react-hook-form');





var _event = require('shared/services/event');
var _SenderPicker = require('./SenderPicker'); var _SenderPicker2 = _interopRequireDefault(_SenderPicker);









const SenderPickerController = ({
  name,
  teamKeyName,
  control,
  resetField,
  teamEntitiesMap,
  defaultSenderKey,
}) => {
  const teamKey = _reacthookform.useWatch.call(void 0, { control, name: teamKeyName }) 
  // Clear the sender only when the team changes, so an existing campaign's
  // sender survives the first render.
  const previousTeamKey = _react.useRef.call(void 0, teamKey)

  const teamEntity = teamEntitiesMap[teamKey]

  _react.useEffect.call(void 0, 
    () => {
      if (previousTeamKey.current === teamKey) return
      previousTeamKey.current = teamKey
      resetField(name, { defaultValue: _nullishCoalesce(defaultSenderKey, () => ( '')) })
    },
    [resetField, name, teamKey, defaultSenderKey],
  )

  if (!teamEntity) return null
  return (
    _react2.default.createElement(_reacthookform.Controller, {
      name: name,
      control: control,
      render: 
        ({ field }) => (
          _react2.default.createElement(_SenderPicker2.default, {
            senderKey: field.value ,
            onSelectSender: k => field.onChange(_event.makeChangeEvent.call(void 0, k)),
            teamKey: teamKey,
            orgKey: teamEntity.wrappedEntity.OrgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
          )
        )
      , __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}
    )
  )
}

exports. default = SenderPickerController
